import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "closing-history-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "header-actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "stats-bar" }
const _hoisted_6 = { class: "stat-item" }
const _hoisted_7 = { class: "stat-value" }
const _hoisted_8 = { class: "stat-item pending" }
const _hoisted_9 = { class: "stat-value" }
const _hoisted_10 = { class: "stat-item ready" }
const _hoisted_11 = { class: "stat-value" }
const _hoisted_12 = { class: "stat-item closed" }
const _hoisted_13 = { class: "stat-value" }
const _hoisted_14 = { class: "stat-item requested" }
const _hoisted_15 = { class: "stat-value" }
const _hoisted_16 = { class: "stat-item completed" }
const _hoisted_17 = { class: "stat-value" }
const _hoisted_18 = { class: "closing-table sortable" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  colspan: "9",
  class: "loading-row"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  colspan: "9",
  class: "empty-row"
}
const _hoisted_23 = ["rowspan"]
const _hoisted_24 = { class: "period-text" }
const _hoisted_25 = { class: "col-bank" }
const _hoisted_26 = { class: "bank-info" }
const _hoisted_27 = { class: "bank-alias" }
const _hoisted_28 = {
  key: 0,
  class: "bank-name"
}
const _hoisted_29 = { class: "col-adjust" }
const _hoisted_30 = { class: "progress-bar" }
const _hoisted_31 = { class: "col-amount income" }
const _hoisted_32 = { class: "col-amount expense" }
const _hoisted_33 = { class: "col-status" }
const _hoisted_34 = ["value", "onChange", "disabled"]
const _hoisted_35 = { class: "col-status" }
const _hoisted_36 = ["value", "onChange", "disabled", "title"]
const _hoisted_37 = ["value"]
const _hoisted_38 = {
  key: 0,
  value: "completed"
}
const _hoisted_39 = ["value"]
const _hoisted_40 = {
  key: 0,
  value: "request_modify"
}
const _hoisted_41 = {
  key: 1,
  value: "request_delete"
}
const _hoisted_42 = {
  key: 2,
  value: "revert_to_requested"
}
const _hoisted_43 = { class: "col-memo" }
const _hoisted_44 = { class: "memo-cell" }
const _hoisted_45 = {
  key: 0,
  class: "memo-text"
}
const _hoisted_46 = ["onClick", "title"]
const _hoisted_47 = { class: "col-history" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "dialog-subtitle" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "dialog-subtitle" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  key: 0,
  class: "history-loading"
}
const _hoisted_54 = {
  key: 1,
  class: "history-empty"
}
const _hoisted_55 = {
  key: 2,
  class: "history-list"
}
const _hoisted_56 = { class: "history-icon" }
const _hoisted_57 = { class: "history-content" }
const _hoisted_58 = { class: "history-main" }
const _hoisted_59 = { class: "history-action" }
const _hoisted_60 = {
  key: 0,
  class: "history-user"
}
const _hoisted_61 = { class: "history-time" }
const _hoisted_62 = {
  key: 0,
  class: "history-memo"
}

import { ref, computed, onMounted, inject, watch, nextTick, type Ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { closingApi } from '@/services/api';

// 희망이음 요청 타입 정의
type HeumieumRequestType = 'register' | 'delete' | 'modify'; 

interface SummaryItem {
  bankCode: string;
  bankAlias: string;
  bankName: string;
  year: number;
  month: number;
  totalCount: number;
  adjustedCount: number;
  totalIncome: number;
  totalExpense: number;
  accountAdjustClosed: boolean;
  accountAdjustClosedAt: string | null;
  heumieumStatus: 'requested' | 'completed' | null;
  heumieumRequestType: HeumieumRequestType | null;
  heumieumRequestAt: string | null;
  memo: string | null;
}

type SortKey = 'period' | 'bank' | 'adjust' | 'income' | 'expense' | 'accountStatus' | 'heumieumStatus';
type SortDir = 'asc' | 'desc' | null;

interface HistoryItem {
  idx: number;
  ccIdx: number;
  action: string;
  requestType: string | null;
  prevStatus: string | null;
  newStatus: string | null;
  year: number;
  month: number;
  bankCode: string;
  memo: string | null;
  createdAt: string;
  createdByName: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberDetailClosingHistory',
  setup(__props) {

const HEUMIEUM_REQUEST_TYPES: Record<HeumieumRequestType, { label: string; shortLabel: string }> = {
  register: { label: '등록요청', shortLabel: '등록' },
  delete: { label: '삭제요청', shortLabel: '삭제' },
  modify: { label: '수정요청', shortLabel: '수정' }
};

const router = useRouter();
const route = useRoute();
const store = useStore();

const memberData = inject<any>('memberData');
const selectedBizGubunRef = inject<Ref<string>>('selectedBizGubun');
const accountingBizGubun = computed(() => selectedBizGubunRef?.value || '');

// 관리자 이상 권한 체크 (role_level >= 60)
const isAdmin = computed(() => {
  const user = store.state.user;
  const roleLevel = user?.roleLevel || user?.role_level || 0;
  return roleLevel >= 60;
});

const memberCode = computed(() => {
  return route.params.memberCode as string || String(memberData?.value?.m_code || '');
});

const isLoading = ref(false);
const isProcessing = ref(false);
const isSavingMemo = ref(false);
const summaryList = ref<SummaryItem[]>([]);

// 테이블 스크롤 위치 유지
const tableCardRef = ref<HTMLDivElement | null>(null);
let savedScrollTop = 0;

const saveScrollPosition = () => {
  if (tableCardRef.value) {
    savedScrollTop = tableCardRef.value.scrollTop;
  }
};

const restoreScrollPosition = () => {
  if (tableCardRef.value) {
    tableCardRef.value.scrollTop = savedScrollTop;
  }
};

// 정렬 상태
const sortKey = ref<SortKey | null>(null);
const sortDir = ref<SortDir>(null);

// 메모 다이얼로그
const memoDialog = ref({
  show: false,
  year: 0,
  month: 0,
  bankCode: '',
  bankAlias: '',
  memo: ''
});

// 이력 다이얼로그
const historyDialog = ref({
  show: false,
  year: 0,
  month: 0,
  bankCode: '',
  bankAlias: ''
});
const historyList = ref<HistoryItem[]>([]);
const isLoadingHistory = ref(false);

const summaryStats = computed(() => {
  const list = summaryList.value;
  return {
    totalPeriods: list.length,
    pendingPeriods: list.filter(i => i.adjustedCount < i.totalCount).length,
    readyPeriods: list.filter(i => i.adjustedCount === i.totalCount && !i.accountAdjustClosed).length,
    closedPeriods: list.filter(i => i.accountAdjustClosed && !i.heumieumStatus).length,
    requestedPeriods: list.filter(i => i.heumieumStatus === 'requested').length,
    completedPeriods: list.filter(i => i.heumieumStatus === 'completed').length
  };
});

// 정렬된 리스트
const sortedList = computed(() => {
  let list = [...summaryList.value];
  
  if (sortKey.value && sortDir.value) {
    const dir = sortDir.value === 'asc' ? 1 : -1;
    
    list = list.sort((a, b) => {
      switch (sortKey.value) {
        case 'period':
          const periodA = a.year * 100 + a.month;
          const periodB = b.year * 100 + b.month;
          return (periodA - periodB) * dir;
        
        case 'bank':
          return a.bankAlias.localeCompare(b.bankAlias) * dir;
        
        case 'adjust':
          const rateA = a.totalCount > 0 ? a.adjustedCount / a.totalCount : 0;
          const rateB = b.totalCount > 0 ? b.adjustedCount / b.totalCount : 0;
          return (rateA - rateB) * dir;
        
        case 'income':
          return (a.totalIncome - b.totalIncome) * dir;
        
        case 'expense':
          return (a.totalExpense - b.totalExpense) * dir;
        
        case 'accountStatus':
          const statusA = a.accountAdjustClosed ? 2 : (a.adjustedCount === a.totalCount ? 1 : 0);
          const statusB = b.accountAdjustClosed ? 2 : (b.adjustedCount === b.totalCount ? 1 : 0);
          return (statusA - statusB) * dir;
        
        case 'heumieumStatus':
          const hStatusMap: Record<string, number> = { 'completed': 3, 'requested': 2 };
          const hStatusA = a.heumieumStatus ? hStatusMap[a.heumieumStatus] : (a.accountAdjustClosed ? 1 : 0);
          const hStatusB = b.heumieumStatus ? hStatusMap[b.heumieumStatus] : (b.accountAdjustClosed ? 1 : 0);
          return (hStatusA - hStatusB) * dir;
        
        default:
          return 0;
      }
    });
  }
  
  return list;
});

// 연월 그룹 정보 계산
const periodGroups = computed(() => {
  const groups = new Map<string, number>();
  sortedList.value.forEach(item => {
    const key = `${item.year}_${item.month}`;
    groups.set(key, (groups.get(key) || 0) + 1);
  });
  return groups;
});

// 연월 그룹의 첫 번째 행인지 확인
const isFirstInPeriod = (item: SummaryItem, index: number): boolean => {
  if (index === 0) return true;
  const prev = sortedList.value[index - 1];
  return item.year !== prev.year || item.month !== prev.month;
};

// 연월 그룹의 마지막 행인지 확인
const isLastInPeriod = (item: SummaryItem, index: number): boolean => {
  if (index === sortedList.value.length - 1) return true;
  const next = sortedList.value[index + 1];
  return item.year !== next.year || item.month !== next.month;
};

// 해당 연월의 행 개수
const getPeriodRowCount = (item: SummaryItem): number => {
  const key = `${item.year}_${item.month}`;
  return periodGroups.value.get(key) || 1;
};

// 정렬 토글
const toggleSort = (key: SortKey) => {
  if (sortKey.value === key) {
    if (sortDir.value === 'asc') {
      sortDir.value = 'desc';
    } else if (sortDir.value === 'desc') {
      sortKey.value = null;
      sortDir.value = null;
    }
  } else {
    sortKey.value = key;
    sortDir.value = 'asc';
  }
};

const getSortIcon = (key: SortKey): string => {
  if (sortKey.value !== key) return 'mdi-unfold-more-horizontal';
  if (sortDir.value === 'asc') return 'mdi-arrow-up';
  if (sortDir.value === 'desc') return 'mdi-arrow-down';
  return 'mdi-unfold-more-horizontal';
};

const getSortClass = (key: SortKey): string => {
  return sortKey.value === key && sortDir.value ? 'active' : '';
};

const formatNumber = (num: number | string | null | undefined): string => {
  if (num === null || num === undefined || num === '') return '0';
  const n = Number(num);
  if (isNaN(n)) return '0';
  return n.toLocaleString('ko-KR');
};

const getAdjustPercent = (item: SummaryItem): number => {
  if (item.totalCount === 0) return 0;
  return Math.round((item.adjustedCount / item.totalCount) * 100);
};

const getRowClass = (item: SummaryItem): string => {
  if (item.heumieumStatus === 'completed') return 'row-completed';
  if (item.heumieumStatus === 'requested') return 'row-requested';
  if (item.accountAdjustClosed) return 'row-closed';
  if (item.adjustedCount === item.totalCount) return 'row-ready';
  return 'row-pending';
};

const loadData = async (preserveScroll = false) => {
  if (!memberCode.value) return;
  
  if (!preserveScroll) {
    isLoading.value = true;
  }
  
  try {
    const response = await closingApi.getSummary(memberCode.value, {
      bizGubun: accountingBizGubun.value
    });
    
    if (response.data?.success) {
      summaryList.value = response.data.data.summary || [];
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`마감요청내역 조회 실패: ${message}`);
    console.error('마감요청내역 조회 오류:', error);
  } finally {
    if (!preserveScroll) {
      isLoading.value = false;
    }
  }
};

// 계정조정 상태 변경 (셀렉트)
const changeAccountStatus = async (item: SummaryItem, newStatus: string) => {
  if (!memberCode.value) return;
  
  const currentStatus = item.accountAdjustClosed ? 'closed' : 'pending';
  if (currentStatus === newStatus) return;
  
  if (newStatus === 'closed') {
    // 마감 처리
    isProcessing.value = true;
    try {
      const response = await closingApi.close(memberCode.value, {
        year: item.year,
        month: item.month,
        type: 'bankbook',
        status: 'account_adjust',
        bizGubun: accountingBizGubun.value,
        bankCode: item.bankCode
      });
      if (response.data?.success) {
        await loadData(true);
      } else {
        throw new Error(response.data?.message || '마감 처리 실패');
      }
    } catch (error: any) {
      alert(`오류: ${error.response?.data?.message || error.message}`);
      await loadData(true); // 실패 시 원래 상태로 복원
    } finally {
      isProcessing.value = false;
    }
  } else {
    // 마감 해제
    // 희망이음 상태가 있으면 경고 후 확인
    if (item.heumieumStatus) {
      const statusLabel = item.heumieumStatus === 'completed' ? '등록완료' : '요청중';
      const confirmed = confirm(
        `현재 희망이음 "${statusLabel}" 상태입니다.\n` +
        `마감을 해제하면 희망이음 상태도 함께 초기화됩니다.\n\n` +
        `정말 마감을 해제하시겠습니까?`
      );
      if (!confirmed) {
        await loadData(true);
        return;
      }
    }
    
    isProcessing.value = true;
    try {
      const response = await closingApi.unclose(memberCode.value, {
        year: item.year,
        month: item.month,
        type: 'bankbook',
        status: 'account_adjust',
        bizGubun: accountingBizGubun.value,
        bankCode: item.bankCode
      });
      if (response.data?.success) {
        await loadData(true);
      } else {
        throw new Error(response.data?.message || '마감 해제 실패');
      }
    } catch (error: any) {
      alert(`오류: ${error.response?.data?.message || error.message}`);
      await loadData(true); // 실패 시 원래 상태로 복원
    } finally {
      isProcessing.value = false;
    }
  }
};

// 희망이음 셀렉트 클래스
const getHeumieumSelectClass = (item: SummaryItem): string => {
  if (item.heumieumStatus === 'completed') {
    const typeClass = item.heumieumRequestType || 'register';
    // 등록완료는 수정/삭제 가능하므로 활성 스타일
    if (typeClass === 'register') {
      return `completed-editable completed-${typeClass}`;
    }
    // 수정/삭제 완료는 최종 상태
    return `completed completed-${typeClass}`;
  }
  if (item.heumieumStatus === 'requested') {
    const typeClass = item.heumieumRequestType || 'register';
    return `requested request-type-${typeClass}`;
  }
  if (!item.accountAdjustClosed) return 'disabled';
  return 'pending';
};

// 희망이음 셀렉트 value 계산
const getHeumieumSelectValue = (item: SummaryItem): string => {
  if (item.heumieumStatus === 'completed') {
    return `completed_${item.heumieumRequestType || 'register'}`;
  }
  if (item.heumieumStatus === 'requested') {
    return `request_${item.heumieumRequestType || 'register'}`;
  }
  return 'none';
};

// 희망이음 툴팁
const getHeumieumTitle = (item: SummaryItem): string => {
  if (!item.accountAdjustClosed) return '계정조정 마감 후 선택 가능';
  if (item.heumieumStatus === 'requested') {
    const typeLabel = getRequestTypeLabel(item.heumieumRequestType);
    return `${typeLabel}요청 진행중`;
  }
  if (item.heumieumStatus === 'completed') {
    if (item.heumieumRequestType === 'register') {
      return '등록완료 - 수정/삭제 요청 가능';
    }
    const typeLabel = getRequestTypeLabel(item.heumieumRequestType);
    return `${typeLabel}완료`;
  }
  return '';
};

// 요청 타입 라벨
const getRequestTypeLabel = (requestType: HeumieumRequestType | null): string => {
  if (!requestType) return '등록';
  return HEUMIEUM_REQUEST_TYPES[requestType]?.shortLabel || requestType;
};

// 희망이음 상태 변경 (셀렉트)
const changeHeumieumStatus = async (item: SummaryItem, newValue: string) => {
  if (!memberCode.value) return;
  
  const currentValue = getHeumieumSelectValue(item);
  if (currentValue === newValue) return;
  
  isProcessing.value = true;
  
  try {
    if (newValue === 'none') {
      // 요청 취소 (requested -> none)
      const response = await closingApi.heumieumCancel(memberCode.value, {
        year: item.year,
        month: item.month,
        bankCode: item.bankCode
      });
      if (!response.data?.success) {
        throw new Error(response.data?.message || '취소 실패');
      }
    } else if (newValue.startsWith('request_')) {
      // 새 요청 생성
      const requestType = newValue.replace('request_', '') as HeumieumRequestType;
      const typeLabel = HEUMIEUM_REQUEST_TYPES[requestType]?.label || requestType;
      
      // 이미 요청중인 상태면 먼저 취소
      if (item.heumieumStatus === 'requested') {
        const cancelResponse = await closingApi.heumieumCancel(memberCode.value, {
          year: item.year,
          month: item.month,
          bankCode: item.bankCode
        });
        if (!cancelResponse.data?.success) {
          throw new Error(cancelResponse.data?.message || '기존 요청 취소 실패');
        }
      }
      
      // 새 요청 생성 (미등록, 요청중 타입변경, 등록완료 후 수정/삭제 모두 포함)
      const response = await closingApi.heumieumRequest(memberCode.value, {
        year: item.year,
        month: item.month,
        bizGubun: accountingBizGubun.value,
        bankCode: item.bankCode,
        bankAlias: item.bankAlias,
        requestType: requestType
      });
      if (!response.data?.success) {
        throw new Error(response.data?.message || `${typeLabel} 실패`);
      }
    } else if (newValue === 'completed') {
      // 완료 처리 (requested -> completed)
      const response = await closingApi.heumieumComplete(memberCode.value, {
        year: item.year,
        month: item.month,
        bankCode: item.bankCode
      });
      if (!response.data?.success) {
        throw new Error(response.data?.message || '완료 처리 실패');
      }
    } else if (newValue === 'revert_to_requested') {
      // 등록완료 -> 등록요청중으로 되돌리기 (관리자 전용)
      const confirmed = confirm('등록완료 상태를 등록요청중으로 되돌리시겠습니까?');
      if (!confirmed) {
        isProcessing.value = false;
        await loadData(true);
        return;
      }
      
      const response = await closingApi.heumieumRevertToRequested(memberCode.value, {
        year: item.year,
        month: item.month,
        bankCode: item.bankCode
      });
      if (!response.data?.success) {
        throw new Error(response.data?.message || '되돌리기 실패');
      }
    }
    await loadData(true);
  } catch (error: any) {
    alert(`오류: ${error.response?.data?.message || error.message}`);
    await loadData(true); // 실패 시 원래 상태로 복원
  } finally {
    isProcessing.value = false;
  }
};

const goToDetail = (item: SummaryItem) => {
  router.push({
    name: 'memberDetailBankbook',
    params: { memberCode: memberCode.value },
    query: {
      year: item.year.toString(),
      month: item.month.toString(),
      bank: item.bankCode
    }
  });
};

// 메모 관련
const openMemoDialog = (item: SummaryItem) => {
  memoDialog.value = {
    show: true,
    year: item.year,
    month: item.month,
    bankCode: item.bankCode,
    bankAlias: item.bankAlias,
    memo: item.memo || ''
  };
};

const closeMemoDialog = () => {
  memoDialog.value.show = false;
};

const saveMemo = async () => {
  if (!memberCode.value) {
    return;
  }
  if (isSavingMemo.value) {
    return;
  }
  
  isSavingMemo.value = true;
  
  try {
    const response = await closingApi.updateMemo(memberCode.value, {
      year: memoDialog.value.year,
      month: memoDialog.value.month,
      bankCode: memoDialog.value.bankCode,
      memo: memoDialog.value.memo,
      bizGubun: accountingBizGubun.value
    });

    if (response.data?.success) {
      closeMemoDialog();
      await loadData(true);
    } else {
      throw new Error(response.data?.message || '메모 저장 실패');
    }
  } catch (error: any) {
    console.error('메모 저장 오류:', error);
    alert(`메모 저장 실패: ${error.response?.data?.message || error.message}`);
  } finally {
    isSavingMemo.value = false;
  }
};

// 이력 관련
const openHistoryDialog = async (item: SummaryItem) => {
  historyDialog.value = {
    show: true,
    year: item.year,
    month: item.month,
    bankCode: item.bankCode,
    bankAlias: item.bankAlias
  };
  
  await loadHistory(item.year, item.month, item.bankCode);
};

const closeHistoryDialog = () => {
  historyDialog.value.show = false;
  historyList.value = [];
};

const loadHistory = async (year: number, month: number, bankCode: string) => {
  if (!memberCode.value) return;
  
  isLoadingHistory.value = true;
  
  try {
    const response = await closingApi.getHistory(memberCode.value, {
      year,
      month,
      bankCode
    });
    
    if (response.data?.success) {
      historyList.value = response.data.data || [];
    }
  } catch (error: any) {
    console.error('이력 조회 오류:', error);
    historyList.value = [];
  } finally {
    isLoadingHistory.value = false;
  }
};

const getHistoryIcon = (action: string): string => {
  switch (action) {
    case 'request': return 'mdi-send';
    case 'complete': return 'mdi-check-circle';
    case 'cancel': return 'mdi-close-circle';
    case 'type_change': return 'mdi-swap-horizontal';
    case 'revert': return 'mdi-undo';
    default: return 'mdi-circle-small';
  }
};

const getHistoryActionLabel = (action: string, requestType: string | null): string => {
  const typeLabel = requestType ? HEUMIEUM_REQUEST_TYPES[requestType as HeumieumRequestType]?.label || requestType : '';
  
  switch (action) {
    case 'request': return `${typeLabel}요청`;
    case 'complete': return `${typeLabel}완료`;
    case 'cancel': return `${typeLabel}취소`;
    case 'type_change': return `타입 변경 → ${typeLabel}`;
    case 'revert': return '요청중으로 되돌림';
    default: return action;
  }
};

const formatDateTime = (dateStr: string): string => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hour = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${year}.${month}.${day} ${hour}:${min}`;
};

watch(accountingBizGubun, () => {
  loadData();
});

onMounted(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title-area" }, [
        _createElementVNode("h2", { class: "page-title" }, "마감요청내역"),
        _createElementVNode("p", { class: "page-subtitle" }, "월별 계정조정 마감 및 희망이음 업로드 현황")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn-refresh",
          onClick: _cache[0] || (_cache[0] = () => loadData()),
          disabled: isLoading.value
        }, [
          _createVNode(_component_v_icon, { size: "18" }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("mdi-refresh", -1)
            ]))]),
            _: 1
          }),
          _cache[12] || (_cache[12] = _createTextVNode(" 새로고침 ", -1))
        ], 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(summaryStats.value.totalPeriods), 1),
        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "stat-label" }, "전체", -1))
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "stat-divider" }, null, -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(summaryStats.value.pendingPeriods), 1),
        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "stat-label" }, "조정 중", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, _toDisplayString(summaryStats.value.readyPeriods), 1),
        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "stat-label" }, "마감가능", -1))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(summaryStats.value.closedPeriods), 1),
        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "stat-label" }, "마감완료", -1))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, _toDisplayString(summaryStats.value.requestedPeriods), 1),
        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "stat-label" }, "요청중", -1))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, _toDisplayString(summaryStats.value.completedPeriods), 1),
        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "stat-label" }, "완료", -1))
      ])
    ]),
    _createElementVNode("div", {
      class: "table-card",
      ref_key: "tableCardRef",
      ref: tableCardRef
    }, [
      _createElementVNode("table", _hoisted_18, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              class: "col-period sortable-th",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSort('period')))
            }, [
              _cache[21] || (_cache[21] = _createTextVNode(" 연월 ", -1)),
              _createVNode(_component_v_icon, {
                size: "14",
                class: _normalizeClass(["sort-icon", getSortClass('period')])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getSortIcon('period')), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _createElementVNode("th", {
              class: "col-bank sortable-th",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSort('bank')))
            }, [
              _cache[22] || (_cache[22] = _createTextVNode(" 통장 ", -1)),
              _createVNode(_component_v_icon, {
                size: "14",
                class: _normalizeClass(["sort-icon", getSortClass('bank')])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getSortIcon('bank')), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _createElementVNode("th", {
              class: "col-adjust sortable-th",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleSort('adjust')))
            }, [
              _cache[23] || (_cache[23] = _createTextVNode(" 계정조정 ", -1)),
              _createVNode(_component_v_icon, {
                size: "14",
                class: _normalizeClass(["sort-icon", getSortClass('adjust')])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getSortIcon('adjust')), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _createElementVNode("th", {
              class: "col-amount sortable-th",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSort('income')))
            }, [
              _cache[24] || (_cache[24] = _createTextVNode(" 수입 ", -1)),
              _createVNode(_component_v_icon, {
                size: "14",
                class: _normalizeClass(["sort-icon", getSortClass('income')])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getSortIcon('income')), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _createElementVNode("th", {
              class: "col-amount sortable-th",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleSort('expense')))
            }, [
              _cache[25] || (_cache[25] = _createTextVNode(" 지출 ", -1)),
              _createVNode(_component_v_icon, {
                size: "14",
                class: _normalizeClass(["sort-icon", getSortClass('expense')])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getSortIcon('expense')), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _createElementVNode("th", {
              class: "col-status sortable-th",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleSort('accountStatus')))
            }, [
              _cache[26] || (_cache[26] = _createTextVNode(" 계정조정 ", -1)),
              _createVNode(_component_v_icon, {
                size: "14",
                class: _normalizeClass(["sort-icon", getSortClass('accountStatus')])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getSortIcon('accountStatus')), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _createElementVNode("th", {
              class: "col-status sortable-th",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleSort('heumieumStatus')))
            }, [
              _cache[27] || (_cache[27] = _createTextVNode(" 희망이음 ", -1)),
              _createVNode(_component_v_icon, {
                size: "14",
                class: _normalizeClass(["sort-icon", getSortClass('heumieumStatus')])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getSortIcon('heumieumStatus')), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("th", { class: "col-memo" }, "메모", -1)),
            _cache[29] || (_cache[29] = _createElementVNode("th", { class: "col-history" }, "이력", -1))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                _createElementVNode("td", _hoisted_20, [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    size: "24",
                    width: "2",
                    color: "#1e3a5f"
                  }),
                  _cache[30] || (_cache[30] = _createElementVNode("span", null, "데이터 로딩중...", -1))
                ])
              ]))
            : (summaryList.value.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                  _createElementVNode("td", _hoisted_22, [
                    _createVNode(_component_v_icon, {
                      size: "40",
                      color: "#d1d5db"
                    }, {
                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                        _createTextVNode("mdi-file-document-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[32] || (_cache[32] = _createElementVNode("p", null, "통장내역 데이터가 없습니다.", -1))
                  ])
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(sortedList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `${item.bankCode}_${item.year}_${item.month}`,
                    class: _normalizeClass([getRowClass(item), { 'period-first': isFirstInPeriod(item, index), 'period-last': isLastInPeriod(item, index) }])
                  }, [
                    (isFirstInPeriod(item, index))
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 0,
                          class: "col-period",
                          rowspan: getPeriodRowCount(item)
                        }, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(item.year) + "." + _toDisplayString(String(item.month).padStart(2, '0')), 1)
                        ], 8, _hoisted_23))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(item.bankAlias), 1),
                        (item.bankName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(item.bankName), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_29, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["adjust-progress", { 'all-complete': item.adjustedCount === item.totalCount }])
                      }, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["progress-fill", { complete: item.adjustedCount === item.totalCount }]),
                            style: _normalizeStyle({ width: getAdjustPercent(item) + '%' })
                          }, null, 6)
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["progress-text", { complete: item.adjustedCount === item.totalCount }])
                        }, _toDisplayString(item.adjustedCount) + "/" + _toDisplayString(item.totalCount), 3),
                        (item.adjustedCount === item.totalCount)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              size: "16",
                              class: "complete-icon"
                            }, {
                              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                _createTextVNode("mdi-check-circle", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(formatNumber(item.totalIncome)), 1),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(formatNumber(item.totalExpense)), 1),
                    _createElementVNode("td", _hoisted_33, [
                      _createElementVNode("select", {
                        class: _normalizeClass(["status-select", item.accountAdjustClosed ? 'closed' : 'pending']),
                        value: item.accountAdjustClosed ? 'closed' : 'pending',
                        onChange: ($event: any) => (changeAccountStatus(item, ($event.target as HTMLSelectElement).value)),
                        disabled: isProcessing.value
                      }, [...(_cache[34] || (_cache[34] = [
                        _createElementVNode("option", { value: "pending" }, "조정중", -1),
                        _createElementVNode("option", { value: "closed" }, "마감완료", -1)
                      ]))], 42, _hoisted_34)
                    ]),
                    _createElementVNode("td", _hoisted_35, [
                      _createElementVNode("select", {
                        class: _normalizeClass(["status-select", getHeumieumSelectClass(item)]),
                        value: getHeumieumSelectValue(item),
                        onChange: ($event: any) => (changeHeumieumStatus(item, ($event.target as HTMLSelectElement).value)),
                        disabled: isProcessing.value || !item.accountAdjustClosed,
                        title: getHeumieumTitle(item)
                      }, [
                        (!item.heumieumStatus)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[35] || (_cache[35] = _createElementVNode("option", { value: "none" }, "-", -1)),
                              _cache[36] || (_cache[36] = _createElementVNode("option", { value: "request_register" }, "등록요청", -1))
                            ], 64))
                          : (item.heumieumStatus === 'requested')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[37] || (_cache[37] = _createElementVNode("option", { value: "none" }, "취소", -1)),
                                _createElementVNode("option", {
                                  value: getHeumieumSelectValue(item),
                                  selected: ""
                                }, _toDisplayString(getRequestTypeLabel(item.heumieumRequestType)) + "요청중 ", 9, _hoisted_37),
                                (item.heumieumRequestType === 'delete')
                                  ? (_openBlock(), _createElementBlock("option", _hoisted_38, "완료처리"))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (item.heumieumStatus === 'completed')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createElementVNode("option", {
                                    value: getHeumieumSelectValue(item),
                                    selected: ""
                                  }, _toDisplayString(getRequestTypeLabel(item.heumieumRequestType)) + "완료 ", 9, _hoisted_39),
                                  (item.heumieumRequestType === 'register')
                                    ? (_openBlock(), _createElementBlock("option", _hoisted_40, "수정요청"))
                                    : _createCommentVNode("", true),
                                  (item.heumieumRequestType === 'register')
                                    ? (_openBlock(), _createElementBlock("option", _hoisted_41, "삭제요청"))
                                    : _createCommentVNode("", true),
                                  (isAdmin.value && item.heumieumRequestType === 'register')
                                    ? (_openBlock(), _createElementBlock("option", _hoisted_42, "요청중으로 되돌리기"))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                      ], 42, _hoisted_36)
                    ]),
                    _createElementVNode("td", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        (item.memo)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(item.memo), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "memo-btn",
                          onClick: ($event: any) => (openMemoDialog(item)),
                          title: item.memo ? '메모 수정' : '메모 작성'
                        }, [
                          _createVNode(_component_v_icon, { size: "14" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.memo ? 'mdi-pencil' : 'mdi-plus'), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 8, _hoisted_46)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_47, [
                      _createElementVNode("button", {
                        class: "history-btn",
                        onClick: ($event: any) => (openHistoryDialog(item)),
                        title: "이력 보기"
                      }, [
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                            _createTextVNode("mdi-history", -1)
                          ]))]),
                          _: 1
                        })
                      ], 8, _hoisted_48)
                    ])
                  ], 2))
                }), 128))
        ])
      ])
    ], 512),
    _createVNode(_component_v_dialog, {
      modelValue: memoDialog.value.show,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((memoDialog.value.show) = $event)),
      "max-width": "450"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "memo-dialog" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "dialog-title" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "20" }, {
                  default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                    _createTextVNode("mdi-note-text", -1)
                  ]))]),
                  _: 1
                }),
                _cache[41] || (_cache[41] = _createTextVNode(" 메모 ", -1)),
                _createElementVNode("span", _hoisted_49, _toDisplayString(memoDialog.value.year) + "." + _toDisplayString(String(memoDialog.value.month).padStart(2, '0')) + " " + _toDisplayString(memoDialog.value.bankAlias), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "dialog-close",
                  "aria-label": "닫기",
                  disabled: isSavingMemo.value,
                  onClick: closeMemoDialog
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_50)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "dialog-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: memoDialog.value.memo,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((memoDialog.value.memo) = $event)),
                  placeholder: "메모를 입력 후 엔터",
                  variant: "outlined",
                  "hide-details": "",
                  density: "comfortable",
                  autofocus: "",
                  onKeydown: _withKeys(_withModifiers(saveMemo, ["prevent"]), ["enter"])
                }, null, 8, ["modelValue", "onKeydown"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dialog-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  onClick: closeMemoDialog
                }, {
                  default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-save",
                  onClick: saveMemo,
                  loading: isSavingMemo.value
                }, {
                  default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                    _createTextVNode(" 저장 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: historyDialog.value.show,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((historyDialog.value.show) = $event)),
      "max-width": "650"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "history-dialog" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "dialog-title" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "20" }, {
                  default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                    _createTextVNode("mdi-history", -1)
                  ]))]),
                  _: 1
                }),
                _cache[46] || (_cache[46] = _createTextVNode(" 희망이음 요청 이력 ", -1)),
                _createElementVNode("span", _hoisted_51, _toDisplayString(historyDialog.value.year) + "." + _toDisplayString(String(historyDialog.value.month).padStart(2, '0')) + " " + _toDisplayString(historyDialog.value.bankAlias), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "dialog-close",
                  "aria-label": "닫기",
                  disabled: isLoadingHistory.value,
                  onClick: closeHistoryDialog
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_52)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "dialog-content" }, {
              default: _withCtx(() => [
                (isLoadingHistory.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        size: "24",
                        width: "2",
                        color: "#1e3a5f"
                      }),
                      _cache[47] || (_cache[47] = _createElementVNode("span", null, "이력 로딩중...", -1))
                    ]))
                  : (historyList.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _createVNode(_component_v_icon, {
                          size: "32",
                          color: "#d1d5db"
                        }, {
                          default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                            _createTextVNode("mdi-history", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[49] || (_cache[49] = _createElementVNode("p", null, "이력이 없습니다.", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, (h) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: h.idx,
                            class: _normalizeClass(["history-item", `action-${h.action}`])
                          }, [
                            _createElementVNode("div", _hoisted_56, [
                              _createVNode(_component_v_icon, { size: "16" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(getHistoryIcon(h.action)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("span", _hoisted_59, _toDisplayString(getHistoryActionLabel(h.action, h.requestType)), 1),
                                (h.createdByName)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(h.createdByName), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_61, _toDisplayString(formatDateTime(h.createdAt)), 1),
                              (h.memo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(h.memo), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 2))
                        }), 128))
                      ]))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dialog-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-close",
                  onClick: closeHistoryDialog
                }, {
                  default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})